import React from 'react'

const Frontend = () => {
    return (
        <div className='skills_content'>
            <h3 className="skills_title">Frontend developer</h3>

            <div className="skills_box">
                <div className="skills_group">
                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">HTML5</h3>
                            <span className="skills_level">Advanced</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">CSS3</h3>
                            <span className="skills_level">Advanced</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">JavaScript</h3>
                            <span className="skills_level">Advanced</span>
                        </div>
                    </div>
                </div>

                <div className="skills_group">
                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">Bootstrap</h3>
                            <span className="skills_level">Intermediate</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">Git</h3>
                            <span className="skills_level">Intermediate
                            </span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className='bx bx-badge-check'></i>

                        <div>
                            <h3 className="skills_className">React</h3>
                            <span className="skills_level">Intermediate</span>
                        </div>
                    </div>
                </div>
            </div>










        </div>




    )
}

export default Frontend
